import React from 'react';
import { string, shape } from 'prop-types';
import { getThemeObj, toKey } from '@/helpers/index';
import Accent from '@/components/typography/Accent';
import Paragraph from '@/components/typography/Paragraph';
import {
  SSkillDetails,
  SSkillTitle,
  SSkillExperience,
  SSkillDescription,
} from './styles';

const SkillDetails = ({ skill, theme }) => {
  const themeColor = getThemeObj(theme).color;
  const regex = new RegExp(/\.\s/);
  const paragraphs = skill.description.split(regex);
  const description = paragraphs.map((p, i) => (
    <Paragraph key={`${i}-${toKey(p.slice(0, 5))}`}>
      {p}
      {i < paragraphs.length - 1 && '.'}
    </Paragraph>
  ));

  const name = skill.name;

  return (
    <SSkillDetails>
      <SSkillTitle data-testid={`skill-${toKey(name)}`} color={themeColor}>
        {name}
      </SSkillTitle>
      <SSkillExperience>
        Experience: <Accent>{skill.experience}</Accent>
      </SSkillExperience>

      {skill.description && (
        <SSkillDescription>{description}</SSkillDescription>
      )}
    </SSkillDetails>
  );
};

SkillDetails.propTypes = {
  skill: shape({
    name: string.isRequired,
    experience: string.isRequired,
    description: string,
  }).isRequired,
  theme: string.isRequired,
};

export default SkillDetails;
